import Bugsnag from "@bugsnag/js";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BooleanParam, StringParam, useQueryParams } from "use-query-params";

import axiosInstance from "../../../axiosInstance";
import { trackEvent } from "../../../helperFunctions";
import URL from "../../../urls";
import AIIntroModal from "./AIIntroModal";

const AIConsentModal = () => {
  const user = useSelector(state => state.auth.user);
  const isAIEnabled = useSelector(state => state.featureFlags.ai_enabled);
  const isAIChatFeatureEnabled = useSelector(
    state => state.featureFlags.ai_chat_feature
  );
  const isAIReportEnabled = useSelector(
    state =>
      state.featureFlags.is_ai_report_enabled ||
      state.featureFlags.ai_intake_report_enabled
  );
  const [queryParams, setQueryParams] = useQueryParams({
    showAIConsentModal: BooleanParam,
    aiConsentSource: StringParam,
  });

  const { aiConsentSource } = queryParams || {};

  const stepFlags = {
    sessionNotes: !!isAIEnabled,
    intakeReports: !!isAIReportEnabled,
    aiChat: !!isAIChatFeatureEnabled,
  };

  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    const fetchConsent = async () => {
      try {
        if (!user?.id) return;

        setIsEnabled(
          (
            await axiosInstance.get(URL.aiPermission, {
              params: { user_ids: user.id },
            })
          )?.data?.data?.[user.id]
        );
      } catch (err) {
        Bugsnag.notify(err);
      }
    };

    fetchConsent();
  }, [user]);

  const onClose = () => {
    setQueryParams({ showAIConsentModal: null }, "replaceIn");
    localStorage.setItem("aiPermissionModalShown", "true");
  };

  const saveConsent = async () => {
    try {
      await axiosInstance.post(URL.aiPermission, {
        permission: isEnabled,
      });
      trackEvent({
        event: isEnabled ? "twa_ai_enabled" : "twa_ai_disabled",
        payload: { source: aiConsentSource },
      });
    } catch (err) {
      Bugsnag.notify(err);
    } finally {
      onClose();
    }
  };

  return (
    <AIIntroModal
      onClose={onClose}
      onSave={saveConsent}
      isEnabled={isEnabled}
      setIsEnabled={setIsEnabled}
      stepFlags={stepFlags}
    />
  );
};

export default AIConsentModal;
